import { css, styled, theme, utils } from 'ui/theme';

const prefixSuffix = css`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: ${theme.space[0]} ${theme.space[1]};
  position: absolute;
  top: ${theme.space[0]};
  width: ${theme.sizes[10]};
`;

export const Input = {
  Input: styled.input`
    appearance: none;
    background: ${theme.colors.build.lightLight};
    ${utils.transition('box-shadow').easing('sharp').duration('shortest')};
    border-radius: ${theme.radii.small};
    border: none;
    box-shadow: 0 0 0 1px ${theme.colors.build.mediumMedium};
    box-sizing: border-box;
    color: ${theme.colors.build.mediumMedium};
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.md};
    font-weight: ${theme.fontWeights.regular};
    height: 100%;
    padding: ${theme.space[4]};
    width: 100%;

    /* Remove default styles for shadow dom elements */
    &::-webkit-search-cancel-button,
    &::-webkit-search-decoration {
      appearance: none;
    }

    ::placeholder {
      color: ${theme.colors.build.mediumMedium};
      font-family: ${theme.fonts.primary};
      font-size: ${theme.fontSizes.md};

      font-weight: ${theme.fontWeights.regular};
    }

    &[data-ghost='true'] {
      background: transparent;
    }

    &[data-error='true'] {
      box-shadow: 0 0 0 2px ${theme.colors.status.error.standard};
    }

    &[data-success='true'] {
      box-shadow: 0 0 0 2px ${theme.colors.status.success.standard};
    }

    &:focus,
    &:focus-visible {
      box-shadow: ${theme.shadows.down.mid},
        0 0 0 2px ${theme.colors.action.navigation.standard.static};
      outline: none;
    }

    &:disabled {
      background: ${theme.colors.action.navigation.standard.disabled};
      box-shadow: 0 0 0 1px ${theme.colors.action.navigation.standard.disabled};
      color: ${theme.colors.build.mediumMedium};
    }

    &:disabled::placeholder {
      color: ${theme.colors.build.mediumMedium};
    }

    &[data-hasprefix='true'] {
      padding-left: ${theme.space[12]};
    }

    &[data-hassuffix='true'] {
      padding-right: ${theme.space[12]};
    }

    &[type='search'] {
      appearance: none;
    }
  `,

  Label: styled.label`
    display: inline-block;
    position: relative;
    width: 100%;
    height: 100%;
  `,

  Prefix: styled.div`
    ${prefixSuffix}
    left: ${theme.space[0]};
  `,

  Suffix: styled.div`
    ${prefixSuffix}
    right: ${theme.space[0]};
  `,
};
